(async () => {
  if (!customElements.get('attention-bar')) {
    const { default: Swiper, Autoplay } = await import("swiper");

    Swiper.use([
      Autoplay
    ]);

    class AttentionBar extends HTMLElement {
      constructor() {
        super();

        document.body.classList.add('attention-bar-visible');
        this.swiperElement = this.querySelector('[data-swiper-attention-bar]');
        this.closeButton = document.body.querySelector('[data-attention-bar-close]');
        this.swiperOptions = {
          loop: true,
          autoplay: true,
          delay: 5000,
          threshold: 10,
          slidesPerView: 1,
          spaceBetween: 10,
          direction: 'horizontal'
        }
        this.init();
      }
      init() {
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

        if(Shopify.designMode && this.swiperInstance) {

          window.addEventListener('shopify:section:load', () => {
            this.swiperInstance.update();
          });

          window.addEventListener('shopify:block:select', (event) => {
            this.swiperInstance.update();
            this.handleThemeEditorEvents(event);
          });
        }

        // custom close button
        this.closeButton?.addEventListener('click', (e) => {
           document.body.classList.remove('attention-bar-visible');
        });
      }

      /**
      * Handles the theme editor block change/edit event
      * @param {Object} event
      */
      handleThemeEditorEvents(event) {
        // Slide to slide based on the data attribute from the target and add 1 to get the slide index
        this.swiperInstance.slideTo(parseInt(event.target.dataset.swiperSlideIndex) + 1);
      }



    }

    window.AttentionBar = AttentionBar;

    customElements.define('attention-bar', AttentionBar);
  }
})();
